/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ActivityTypeOptionsResponse } from '../models';
// @ts-ignore
import type { ClaimDailyMissionBody } from '../models';
// @ts-ignore
import type { CreateDailyMissionBody } from '../models';
// @ts-ignore
import type { DailyMissionResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetAllDailyMissionsResponse } from '../models';
// @ts-ignore
import type { MyDailyMissionsResponse } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { UpdateDailyMissionBody } from '../models';
/**
 * DailyMissionApiApi - axios parameter creator
 */
export const DailyMissionApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ClaimDailyMissionBody} claimDailyMissionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dailyMissionApiClaimMyDailyMissions: async (claimDailyMissionBody: ClaimDailyMissionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimDailyMissionBody' is not null or undefined
            assertParamExists('dailyMissionApiClaimMyDailyMissions', 'claimDailyMissionBody', claimDailyMissionBody)
            const localVarPath = `/daily-missions/claim`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimDailyMissionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateDailyMissionBody} createDailyMissionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dailyMissionApiCreateDailyMission: async (createDailyMissionBody: CreateDailyMissionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDailyMissionBody' is not null or undefined
            assertParamExists('dailyMissionApiCreateDailyMission', 'createDailyMissionBody', createDailyMissionBody)
            const localVarPath = `/daily-mission`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDailyMissionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} missionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dailyMissionApiDeleteDailyMission: async (missionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'missionId' is not null or undefined
            assertParamExists('dailyMissionApiDeleteDailyMission', 'missionId', missionId)
            const localVarPath = `/daily-mission/{mission_id}`
                .replace('{mission_id}', encodeURIComponent(String(missionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dailyMissionApiGetAllDailyMissions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/daily-mission`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Served rather than duplicated in the admin form: the enum is the source of truth for what the activity log actually records, and a hand-copied list on the client would let an admin build a mission that can never complete.
         * @summary The vocabulary a mission may be defined over.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dailyMissionApiGetDailyMissionActivityTypes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/daily-mission/activity-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} missionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dailyMissionApiGetDailyMissionById: async (missionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'missionId' is not null or undefined
            assertParamExists('dailyMissionApiGetDailyMissionById', 'missionId', missionId)
            const localVarPath = `/daily-mission/{mission_id}`
                .replace('{mission_id}', encodeURIComponent(String(missionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dailyMissionApiGetMyDailyMissions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/daily-missions/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} missionId 
         * @param {UpdateDailyMissionBody} updateDailyMissionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dailyMissionApiUpdateDailyMission: async (missionId: string, updateDailyMissionBody: UpdateDailyMissionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'missionId' is not null or undefined
            assertParamExists('dailyMissionApiUpdateDailyMission', 'missionId', missionId)
            // verify required parameter 'updateDailyMissionBody' is not null or undefined
            assertParamExists('dailyMissionApiUpdateDailyMission', 'updateDailyMissionBody', updateDailyMissionBody)
            const localVarPath = `/daily-mission/{mission_id}`
                .replace('{mission_id}', encodeURIComponent(String(missionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDailyMissionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DailyMissionApiApi - functional programming interface
 */
export const DailyMissionApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DailyMissionApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ClaimDailyMissionBody} claimDailyMissionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dailyMissionApiClaimMyDailyMissions(claimDailyMissionBody: ClaimDailyMissionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MyDailyMissionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dailyMissionApiClaimMyDailyMissions(claimDailyMissionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DailyMissionApiApi.dailyMissionApiClaimMyDailyMissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateDailyMissionBody} createDailyMissionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dailyMissionApiCreateDailyMission(createDailyMissionBody: CreateDailyMissionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DailyMissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dailyMissionApiCreateDailyMission(createDailyMissionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DailyMissionApiApi.dailyMissionApiCreateDailyMission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} missionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dailyMissionApiDeleteDailyMission(missionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dailyMissionApiDeleteDailyMission(missionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DailyMissionApiApi.dailyMissionApiDeleteDailyMission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dailyMissionApiGetAllDailyMissions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllDailyMissionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dailyMissionApiGetAllDailyMissions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DailyMissionApiApi.dailyMissionApiGetAllDailyMissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Served rather than duplicated in the admin form: the enum is the source of truth for what the activity log actually records, and a hand-copied list on the client would let an admin build a mission that can never complete.
         * @summary The vocabulary a mission may be defined over.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dailyMissionApiGetDailyMissionActivityTypes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivityTypeOptionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dailyMissionApiGetDailyMissionActivityTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DailyMissionApiApi.dailyMissionApiGetDailyMissionActivityTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} missionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dailyMissionApiGetDailyMissionById(missionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DailyMissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dailyMissionApiGetDailyMissionById(missionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DailyMissionApiApi.dailyMissionApiGetDailyMissionById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dailyMissionApiGetMyDailyMissions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MyDailyMissionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dailyMissionApiGetMyDailyMissions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DailyMissionApiApi.dailyMissionApiGetMyDailyMissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} missionId 
         * @param {UpdateDailyMissionBody} updateDailyMissionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dailyMissionApiUpdateDailyMission(missionId: string, updateDailyMissionBody: UpdateDailyMissionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DailyMissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dailyMissionApiUpdateDailyMission(missionId, updateDailyMissionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DailyMissionApiApi.dailyMissionApiUpdateDailyMission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DailyMissionApiApi - factory interface
 */
export const DailyMissionApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DailyMissionApiApiFp(configuration)
    return {
        /**
         * 
         * @param {DailyMissionApiApiDailyMissionApiClaimMyDailyMissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dailyMissionApiClaimMyDailyMissions(requestParameters: DailyMissionApiApiDailyMissionApiClaimMyDailyMissionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<MyDailyMissionsResponse> {
            return localVarFp.dailyMissionApiClaimMyDailyMissions(requestParameters.claimDailyMissionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DailyMissionApiApiDailyMissionApiCreateDailyMissionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dailyMissionApiCreateDailyMission(requestParameters: DailyMissionApiApiDailyMissionApiCreateDailyMissionRequest, options?: RawAxiosRequestConfig): AxiosPromise<DailyMissionResponse> {
            return localVarFp.dailyMissionApiCreateDailyMission(requestParameters.createDailyMissionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DailyMissionApiApiDailyMissionApiDeleteDailyMissionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dailyMissionApiDeleteDailyMission(requestParameters: DailyMissionApiApiDailyMissionApiDeleteDailyMissionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.dailyMissionApiDeleteDailyMission(requestParameters.missionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dailyMissionApiGetAllDailyMissions(options?: RawAxiosRequestConfig): AxiosPromise<GetAllDailyMissionsResponse> {
            return localVarFp.dailyMissionApiGetAllDailyMissions(options).then((request) => request(axios, basePath));
        },
        /**
         * Served rather than duplicated in the admin form: the enum is the source of truth for what the activity log actually records, and a hand-copied list on the client would let an admin build a mission that can never complete.
         * @summary The vocabulary a mission may be defined over.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dailyMissionApiGetDailyMissionActivityTypes(options?: RawAxiosRequestConfig): AxiosPromise<ActivityTypeOptionsResponse> {
            return localVarFp.dailyMissionApiGetDailyMissionActivityTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DailyMissionApiApiDailyMissionApiGetDailyMissionByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dailyMissionApiGetDailyMissionById(requestParameters: DailyMissionApiApiDailyMissionApiGetDailyMissionByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<DailyMissionResponse> {
            return localVarFp.dailyMissionApiGetDailyMissionById(requestParameters.missionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dailyMissionApiGetMyDailyMissions(options?: RawAxiosRequestConfig): AxiosPromise<MyDailyMissionsResponse> {
            return localVarFp.dailyMissionApiGetMyDailyMissions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DailyMissionApiApiDailyMissionApiUpdateDailyMissionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dailyMissionApiUpdateDailyMission(requestParameters: DailyMissionApiApiDailyMissionApiUpdateDailyMissionRequest, options?: RawAxiosRequestConfig): AxiosPromise<DailyMissionResponse> {
            return localVarFp.dailyMissionApiUpdateDailyMission(requestParameters.missionId, requestParameters.updateDailyMissionBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for dailyMissionApiClaimMyDailyMissions operation in DailyMissionApiApi.
 */
export interface DailyMissionApiApiDailyMissionApiClaimMyDailyMissionsRequest {
    readonly claimDailyMissionBody: ClaimDailyMissionBody
}

/**
 * Request parameters for dailyMissionApiCreateDailyMission operation in DailyMissionApiApi.
 */
export interface DailyMissionApiApiDailyMissionApiCreateDailyMissionRequest {
    readonly createDailyMissionBody: CreateDailyMissionBody
}

/**
 * Request parameters for dailyMissionApiDeleteDailyMission operation in DailyMissionApiApi.
 */
export interface DailyMissionApiApiDailyMissionApiDeleteDailyMissionRequest {
    readonly missionId: string
}

/**
 * Request parameters for dailyMissionApiGetDailyMissionById operation in DailyMissionApiApi.
 */
export interface DailyMissionApiApiDailyMissionApiGetDailyMissionByIdRequest {
    readonly missionId: string
}

/**
 * Request parameters for dailyMissionApiUpdateDailyMission operation in DailyMissionApiApi.
 */
export interface DailyMissionApiApiDailyMissionApiUpdateDailyMissionRequest {
    readonly missionId: string

    readonly updateDailyMissionBody: UpdateDailyMissionBody
}

/**
 * DailyMissionApiApi - object-oriented interface
 */
export class DailyMissionApiApi extends BaseAPI {
    /**
     * 
     * @param {DailyMissionApiApiDailyMissionApiClaimMyDailyMissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dailyMissionApiClaimMyDailyMissions(requestParameters: DailyMissionApiApiDailyMissionApiClaimMyDailyMissionsRequest, options?: RawAxiosRequestConfig) {
        return DailyMissionApiApiFp(this.configuration).dailyMissionApiClaimMyDailyMissions(requestParameters.claimDailyMissionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DailyMissionApiApiDailyMissionApiCreateDailyMissionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dailyMissionApiCreateDailyMission(requestParameters: DailyMissionApiApiDailyMissionApiCreateDailyMissionRequest, options?: RawAxiosRequestConfig) {
        return DailyMissionApiApiFp(this.configuration).dailyMissionApiCreateDailyMission(requestParameters.createDailyMissionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DailyMissionApiApiDailyMissionApiDeleteDailyMissionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dailyMissionApiDeleteDailyMission(requestParameters: DailyMissionApiApiDailyMissionApiDeleteDailyMissionRequest, options?: RawAxiosRequestConfig) {
        return DailyMissionApiApiFp(this.configuration).dailyMissionApiDeleteDailyMission(requestParameters.missionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dailyMissionApiGetAllDailyMissions(options?: RawAxiosRequestConfig) {
        return DailyMissionApiApiFp(this.configuration).dailyMissionApiGetAllDailyMissions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Served rather than duplicated in the admin form: the enum is the source of truth for what the activity log actually records, and a hand-copied list on the client would let an admin build a mission that can never complete.
     * @summary The vocabulary a mission may be defined over.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dailyMissionApiGetDailyMissionActivityTypes(options?: RawAxiosRequestConfig) {
        return DailyMissionApiApiFp(this.configuration).dailyMissionApiGetDailyMissionActivityTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DailyMissionApiApiDailyMissionApiGetDailyMissionByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dailyMissionApiGetDailyMissionById(requestParameters: DailyMissionApiApiDailyMissionApiGetDailyMissionByIdRequest, options?: RawAxiosRequestConfig) {
        return DailyMissionApiApiFp(this.configuration).dailyMissionApiGetDailyMissionById(requestParameters.missionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dailyMissionApiGetMyDailyMissions(options?: RawAxiosRequestConfig) {
        return DailyMissionApiApiFp(this.configuration).dailyMissionApiGetMyDailyMissions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DailyMissionApiApiDailyMissionApiUpdateDailyMissionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dailyMissionApiUpdateDailyMission(requestParameters: DailyMissionApiApiDailyMissionApiUpdateDailyMissionRequest, options?: RawAxiosRequestConfig) {
        return DailyMissionApiApiFp(this.configuration).dailyMissionApiUpdateDailyMission(requestParameters.missionId, requestParameters.updateDailyMissionBody, options).then((request) => request(this.axios, this.basePath));
    }
}

